import { z } from "zod";

/**
 * 本人が修正できるのは氏名とメールアドレスのみ (ADR-0041 Decision 6)。
 * 社員番号・部署・性別は名簿の同一性・集計軸に関わるため schema に持たない。
 *
 * エラー文言は 5 言語 (ADR-0041 Decision 7-1) で出し分ける必要があるため、schema を
 * 文言リテラルではなく翻訳済みメッセージを受け取る factory にしている。
 */
export interface ContactMessages {
  fullNameRequired: string;
  emailRequired: string;
  emailInvalid: string;
}

export function buildContactSchema(messages: ContactMessages) {
  return z.object({
    fullName: z.string().trim().min(1, messages.fullNameRequired),
    email: z.string().trim().min(1, messages.emailRequired).email(messages.emailInvalid),
  });
}

export type ContactFormInput = z.infer<ReturnType<typeof buildContactSchema>>;
